import React, {
  useState,
  useEffect,
  useContext
} from 'react';
import clsx from 'clsx';
import {
  makeStyles,
  Typography,
  Grid,
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableSortLabel,
  TableRow,
  TableCell,
  Toolbar,
  Tooltip,
  Checkbox
} from '@material-ui/core';
import moment from 'moment';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles, lighten } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { DropzoneAreaBase } from 'material-ui-dropzone';

import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';

import ViewArquivo from '../../../shared/component/UIElements/ViewArquivo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  galeria: {
    marginTop: '32px'
  },
  title: {
    backgroundColor: '#2C3E50',
    '& h2': {
      color: 'white',
      fontSize: '18px',
      fontFamily: 'Roboto',
      fontWeight: 500,
    },
  },
  button: {
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
  },
  confirmar: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    background: '#51B36E',
    '&:hover': {
      backgroundColor: '#51B36E',
    }
  },
  direita: {
    textAlign: 'right'
  },
  play: {
    color: '#3E3E3E',
    fontSize: '20px'
  },
  remover: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: '#808080',
    textAlign: 'center',
    maxWidth: '290px',
    margin: '15px auto'
  },
  removerholder: {
    overflowY: 'unset',
    textAlign: 'center',
    padding: '24px'
  },
  sim: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    margin: '5px 15px',
    background: '#C03A2A',
    '&:hover': {
      backgroundColor: '#C03A2A',
    },
    maxWidth: '112px'
  },
  nao: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    margin: '5px 15px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    background: '#808080',
    '&:hover': {
      backgroundColor: '#808080',
    },
    maxWidth: '112px'
  },
}));
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dropzone: {
    margin: '0px 0px 10px 0px',
    width: '100%'
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const {
    children,
    classes,
    onClose,
    ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h2">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}));

const headCells = [
  {
    id: 'nome',
    numeric: false,
    disablePadding: true,
    label: 'Nome'
  },
  {
    id: 'formato',
    numeric: false,
    disablePadding: false,
    label: 'Formato'
  },
  {
    id: 'tamanho',
    numeric: false,
    disablePadding: false,
    label: 'Tamanho'
  },
  {
    id: 'player',
    numeric: false,
    disablePadding: false,
    label: 'Player'
  },
  {
    id: 'data',
    numeric: false,
    disablePadding: false,
    label: 'Data'
  },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  return `${Math.round(bytes / (1024 ** i), 2)}  ${sizes[i]}`;
}

const UploadAnexo = (props) => {
  const classes = useStyles();
  const {
    open,
    onClose,
    confirmar
  } = props;
  const auth = useContext(AuthContext);
  const [arquivos, setArquivos] = useState([]);
  const [uploading, setUploading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [currentUpload, setCurrentUpload] = useState(null);
  const [remover, setRemover] = useState(false);
  const [ver, setVer] = useState(false);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();

  const fechaVer = async () => {
    setVer(false);
  };

  const handleUpload = (files) => {
    setArquivos((prevState) => {
      const data = [...prevState];
      const final = data.concat(files.map((arquivo) => {
        return {
          nome: arquivo.file.name,
          file: arquivo.file,
          criado: false
        };
      }));
      return final;
    });
    setUploading(false);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = arquivos.map((n) => n.nome);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const abreRemove = (event, arqvs) => {
    setRemover(arqvs);
  };
  const handleConfirmarRemove = () => {
    if (Array.isArray(remover)) {
      setArquivos((prevState) => {
        const data = [...prevState.filter((item) => !remover.includes(item.nome))];
        setRemover(false);
        return data;
      });
    } else {
      const paraRemover = arquivos.indexOf(remover);
      if (paraRemover !== -1) {
        setArquivos((prevState) => {
          const data = [...prevState.filter((item) => item !== remover)];
          setRemover(false);
          return data;
        });
      }
    }
  };

  const addMais = async () => {
    setUploading(true);
  };

  const cancelaMais = async () => {
    setUploading(false);
  };

  const fechaRemover = async () => {
    setRemover(false);
  };

  const confirmaAnexos = async () => {
    const a = arquivos;
    setSelected([]);
    setArquivos([]);
    setUploading(true);
    if (confirmar) {
      confirmar(a);
    }
  };

  useEffect(() => {
    const upload = async (arquivo) => {
      if (!arquivo.criado) {
        try {
          setCurrentUpload(arquivo);
          const formulario = new FormData();
          formulario.append('arquivo', arquivo.file);
          const response = await sendRequest(
            `${process.env.REACT_APP_BACKEND_URL}/anexos`,
            'POST',
            formulario,
            {
              'x-access-token': auth.token
            }
          );
          console.log(response);
          if (response.sucesso) {
            setArquivos((prevState) => {
              const antigo = prevState;
              const qual = antigo.indexOf(arquivo);
              delete antigo[qual].file;
              antigo[qual].criado = response.data;
              return antigo;
            });
            clearError();
            setCurrentUpload(null);
          }
        } catch (err) {
          console.log(err);
        }
      }
      return true;
    };
    async function uploads() {
      await Promise.all(
        arquivos.map((arquivo, index) => setTimeout(() => upload(arquivo), 1000 * index))
      );
    }
    if (arquivos.length > 0) {
      uploads();
    }
  }, [arquivos]);

  const EnhancedTableToolbar = (prop) => {
    const classe = useToolbarStyles();
    const { numSelected } = prop;

    return (
      <Toolbar
        className={clsx(classe.root, {
          [classe.highlight]: numSelected > 0,
        })}
      >
        {numSelected > 0 && (
          <Typography className={classe.title} color="inherit" variant="subtitle1" component="div">
            {`${numSelected} selecionado(s)`}
          </Typography>
        )}
        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton
              aria-label="delete"
              onClick={(event) => abreRemove(event, selected)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    );
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        scroll="body"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={onClose}
          className={classes.title}
        >
          Anexos
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={5}>
            {uploading ? (
              <Grid item xs={12}>
                <DropzoneAreaBase
                  acceptedFiles={['audio/*', 'image/*', 'video/*', '.pdf', '.doc', '.docx']}
                  dropzoneText="Arraste arquivos para cá ou clique para selecionar os arquivos."
                  filesLimit={12}
                  Icon={PhotoCameraIcon}
                  dropzoneClass={classes.dropzone}
                  showAlerts={false}
                  maxFileSize={30000000}
                  onAdd={handleUpload}
                  getFileLimitExceedMessage={(filesLimit) => (`Limite máximo de ${filesLimit} arquivos atingido.`)}
                // getFileAddedMessage={(fileName) => (`O arquivo ${fileName} foi adicionado para upload com sucesso.`)}
                // getFileRemovedMessage={(fileName) => (`O arquivo ${fileName} foi rejeitado.`)}
                // getDropRejectMessage={(rejectedFile) => (`O arquivo ${rejectedFile.name} foi rejeitado.`)}
                />
              </Grid>
            ) : (
              <>
                <Grid item xs={12}>
                  <TableContainer>
                    <Table>
                      <EnhancedTableHead
                        classes={classes}
                        numSelected={selected.length}
                        onSelectAllClick={handleSelectAllClick}
                        rowCount={arquivos.length}
                      />
                      <TableBody>
                        {arquivos.map((arquivo, index) => {
                          const isItemSelected = isSelected(arquivo.nome);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              key={arquivo.nome}
                              selected={isItemSelected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  onClick={(event) => handleClick(event, arquivo.nome)}
                                  checked={isItemSelected}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </TableCell>
                              <TableCell>
                                {arquivo.nome}
                              </TableCell>
                              <TableCell>
                                {arquivo.criado !== false ? arquivo.criado.tipo : arquivo.file.type}
                              </TableCell>
                              {arquivo.criado !== false ? (
                                <>
                                  <TableCell>{bytesToSize(arquivo.criado.tamanho)}</TableCell>
                                  <TableCell>
                                    <IconButton
                                      aria-label="visualizar"
                                      className={classes.play}
                                      onClick={() => setVer(arquivo.criado)}
                                    >
                                      <PlayArrowIcon fontSize="medium" />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell>{moment(arquivo.criado.createdDate).format('DD/MM/YYYY HH:mm')}</TableCell>
                                  <TableCell>
                                    <IconButton
                                      aria-label="remover"
                                      className={classes.play}
                                      onClick={(event) => abreRemove(event, arquivo)}
                                    >
                                      <DeleteIcon fontSize="medium" />
                                    </IconButton>
                                  </TableCell>
                                </>
                              ) : (
                                <TableCell colSpan={3}>
                                  {(isLoading && arquivos.indexOf(currentUpload) !== -1) && arquivos.indexOf(currentUpload) === index && <LoadingSpinner asOverlay />}
                                  {arquivos.indexOf(currentUpload) !== -1 && <ErrorMessage error={error} onClear={clearError} />}
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <EnhancedTableToolbar numSelected={selected.length} />
                </Grid>
              </>
            )}
          </Grid>
          <ViewArquivo open={Boolean(ver)} anexo={ver} onClose={fechaVer} />
          {selected.length === 0 && !uploading && (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={addMais}
                  marginBottom={5}
                  className={classes.button}
                >
                  ADICIONAR MAIS ARQUIVOS
                </Button>
              </Grid>
              <Grid item xs={6} className={classes.direita}>
                <Button
                  onClick={confirmaAnexos}
                  marginBottom={5}
                  classes={{
                    root: classes.confirmar
                  }}
                >
                  CONFIRMAR
                </Button>
              </Grid>
            </Grid>
          )}
          {arquivos.length > 0 && uploading && (
            <Grid container spacing={3}>
              <Grid item xs={6} />
              <Grid item xs={6} className={classes.direita}>
                <Button
                  fullWidth
                  marginBottom={5}
                  onClick={cancelaMais}
                  classes={{
                    root: classes.nao
                  }}
                >
                  CANCELAR
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={remover !== false}
        onClose={fechaRemover}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent className={classes.removerholder}>
          <Typography className={classes.remover} color="inherit" variant="subtitle1" component="div">
            Tem certeza que deseja excluir os anexos selecionados?
          </Typography>
          <Button
            fullWidth
            marginBottom={5}
            onClick={fechaRemover}
            classes={{
              root: classes.nao
            }}
          >
            NÃO
          </Button>
          <Button
            fullWidth
            marginBottom={5}
            onClick={handleConfirmarRemove}
            classes={{
              root: classes.sim
            }}
          >
            SIM
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default UploadAnexo;
